import { render, staticRenderFns } from "./StudentAppointmentsList.vue?vue&type=template&id=7ab8846d"
import script from "./StudentAppointmentsList.vue?vue&type=script&lang=js"
export * from "./StudentAppointmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports